async function getTopPerformingFunds(fundType = "ETF", period = "yeartodate") {
    try {
        const blockID = $("#topPerformanceFunds").attr("data-blockid") ?? 0;
        const language = $("#topPerformanceFunds").attr("data-language") ?? "en";
        const country = $("#topPerformanceFunds").attr("data-country");

        if (!blockID) {
            console.error("Block ID is missing");
            return;
        }

        const url = new URL("/Main/TopPerformanceFundsBlock/GetTopPerformanceFunds", window.location.href);
        url.searchParams.set("blockid", blockID);
        url.searchParams.set("fundtype", fundType);
        url.searchParams.set("period", period);
        url.searchParams.set("country", country);
        url.searchParams.set("language", language);

        const response = await fetch(url);
        if (!response.ok) {
            console.error("Network response was not OK");
            return;
        }
        const result = await response.json();
        return result;

    } catch (err) {
        console.error("There has been a problem with fetching funds:", err);
        return;
    }
}

// manipulate data-area
function updateTopPerformingFundList(fundList = null) {
    if (!fundList) return;

    if (fundList.Performances.length < 1) {
        const emptyFundsMessage = `<div>No Funds matching the selected criteria, please change filters.</div>`;
        $("#topPerformanceFunds .data-display-section").append(emptyFundsMessage.trim());
        $("#topPerformanceFunds .as-of-date").addClass("d-none");
        $("#topPerformanceFunds .chart-disclaimer").addClass("d-none");
        return;
    }

    fundList.Performances.forEach((fund, i) => {
        const fundElement = `<div class="fund-item mt-2">
                        <a class="cta-link fundlist-block__cta-item d-flex justify-content-between align-items-center" href="${fund.Url}">
                            <span class="fund-name">${fund.FundName}</span>
                            <span class="font-weight-bold">
                                ${fund.FormattedValue}%
                                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="angle-right" class="svg-inline--fa fa-angle-right fa-w-16 fa-lg cta-link__icon align-middle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M10 7.25a.75.75 0 00-.53.22.75.75 0 000 1.06L12.94 12l-3.47 3.47a.75.75 0 000 1.06.75.75 0 001.06 0l4-4a.75.75 0 000-1.06l-4-4a.75.75 0 00-.52-.22z"></path>
                                </svg>
                            </span>
                        </a>
                    </div>`;

        $("#topPerformanceFunds .data-display-section").append(fundElement.trim());

        $("#topPerformanceFunds .as-of-date span").text(fundList.AsOfDateText);
        $("#topPerformanceFunds .as-of-date").removeClass("d-none");

        $("#topPerformanceFunds .chart-disclaimer").removeClass("d-none");
    });
}

function ucitsHomepageScripts() {
    if ($("#subscribeNewsletterForm").length == 0 && $("#socialNewsletterForm").length == 0 ) return;
    const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    $("#subscribeNewsletterForm,#socialNewsletterForm").on("submit", function (e) {
        e.preventDefault();
        $(this).find(".error-message").hide()
        $(this).removeClass("validation-fail")
        
        var userEmail = $(this).find(".FormTextbox__Input").val()
        if (userEmail.match(emailRegex)) {
            console.log("Form Submitted Successfully!!", $(this).children(".FormTextbox__Input").val())
            localStorage.setItem("userEmail", userEmail);
            var newsletterUrl = $("#newsletterBtn").attr('href');
            window.location.replace(newsletterUrl);
        } else {
            $(this).addClass("validation-fail")
            $(this).find(".error-message").show()
            $(this).find(".FormTextbox__Input").trigger("focus")
            console.log("Invalid email")
        }
        
    })
}

function newsletterPopulationScripts() {
    if ($(".eu-newsletter-page").length == 0) return
    console.log("Inside the function")

    var userEmail = localStorage.getItem("userEmail");

    if (userEmail) {
        localStorage.removeItem("userEmail");
        setTimeout(() => {
            $(".main-subscription-registration-form input.email").val(userEmail);
        },200)
    }
}

function ucitsSearchAutoComplete() {
    if ($("#ucitsSearchForm").length == 0) return

    // if previous search term is cached
    if ($("#ucitsSearchInput").val().trim().length > 0) $("#search-clear").removeClass("invisible");

    var blockId = $("#ucitsSearchForm").attr("data-blockid") ?? 0;
    var language = $("#ucitsSearchForm").attr("data-language") ?? string.empty;
    if (blockId == 0) return;
    var dataList = [];

    fetch(`/Main/FundSearchPanelBlock/GetSearchPanelData?blockId=${blockId}&language=${language}`)
        .then(response => response.json())
        .then(data => {
            if (data.Success) {
                console.log("Request succeeded:", data.Rows);
                dataList = data.Rows;
            } else {
                console.error("Request failed with error:", data.Error);
            }
        })
        .catch(error => {
            console.error("Fetch request failed:", error);
        });

    $("#ucitsSearchInput").on("keyup", function () {
        if ($(this).val().trim().length == 0) {
            $("#fundSearchResultTable").hide();
            return
        }
        $("#fundSearchResultTable tbody").empty();
        var filteredArray = dataList && dataList.map((item, index) => {
            if ((item.Values.filter((item) => item && item.toLowerCase().includes($(this).val().toLowerCase())).length > 0) ||
                (item.Keywords.filter((item) => item.toLowerCase().includes($(this).val().toLowerCase())).length > 0)) return item;
        }).filter((item) => item !== undefined)

        var tbodyMarkup = drawTable(filteredArray && filteredArray)

        $("#fundSearchResultTable tbody").append(tbodyMarkup);
        $("#fundSearchResultTable").show();
        if (filteredArray.length == 0) {
            $("#fundSearchResultTable").hide();
        }
    });

    const drawTable = (arrayItems) => {
        var tableMarkup = "";
        arrayItems.map((item, index) => {
            var url = item.Url;
            var tableRow = "<tr>"
            item.Values.map((subItem, subIndex) => {
                if (!subItem) subItem = "";
                if (subIndex === 0) {
                    tableRow += "<td><a href='" + url + "' class=''>" + subItem + "</a></td>";
                } else {
                    tableRow += "<td>" + subItem + "</td>";
                }
            })
            tableRow += "</tr>"
            tableMarkup += tableRow
        })
        return tableMarkup;
    }

    $("#ucitsSearchInput").on("input", function () {
        if ($(this).val().trim().length == 0)
            $("#search-clear").addClass("invisible");
        else
            $("#search-clear").removeClass("invisible");
    });

    $("#search-clear").on("click", function () {
        $("#ucitsSearchInput").val("");
        $("#fundSearchResultTable").hide();
        $("#ucitsSearchInput").focus().trigger("focus");
        $(this).addClass("invisible");
    });

    function swapPlaceholder () {
        const searchField = document.getElementById("ucitsSearchInput");
        const placeholderText = searchField.getAttribute("data-placeholdertext");
        const mobilePlaceholderText = searchField.getAttribute("data-mobileplaceholdertext");

        if (!placeholderText || !mobilePlaceholderText) return;

        if (window.innerWidth >= 768) {
            searchField.setAttribute("placeholder", placeholderText);
        } else {
            searchField.setAttribute("placeholder", mobilePlaceholderText);
        }
    }

    window.addEventListener('load', swapPlaceholder);
    window.addEventListener('resize', swapPlaceholder);
}

function topPerformningFunds() {
    const topPerformanceFunds = $("#topPerformanceFunds");
    if (!topPerformanceFunds.length) return;

    topPerformanceFunds.find(".data-display-section .fund-section")?.hide();
    const periodButton = topPerformanceFunds.find(".performance-periods button");

    periodButton?.on("click", async function (event) {
        const selectedPeriod = $(this).val().trim();
        let fundTypeElement = topPerformanceFunds.find(".fund-type-dropdown button.fund-type-button:first");
        if (fundTypeElement.length == 0) {
            fundTypeElement = topPerformanceFunds.find("span.fund_type_label:first")
        }
        const selectedFundType = fundTypeElement?.attr("data-selected-val");

        topPerformanceFunds.find(".period-dropdown button.period-button:first")?.data("selected-val", selectedPeriod)?.attr("data-selected-val", selectedPeriod);

        topPerformanceFunds.find(".period_label")?.text($(this).text());

        topPerformanceFunds.find(".data-display-section")?.empty();

        const fundList = await getTopPerformingFunds(selectedFundType, selectedPeriod);
        updateTopPerformingFundList(fundList);
    })

    const fundTypeButton = topPerformanceFunds.find(".performance-fund-types button");
    fundTypeButton?.on("click", async function (event) {
        const selectedFundType = $(this).val().trim();
        const selectedPeriod = topPerformanceFunds.find(".period-dropdown button.period-button:first")?.attr("data-selected-val");

        topPerformanceFunds.find(".fund-type-dropdown button.fund-type-button:first")?.data("selected-val", selectedFundType)?.attr("data-selected-val", selectedFundType);

        topPerformanceFunds.find(".fund_type_label")?.text($(this).text());

        topPerformanceFunds.find(".data-display-section")?.empty();

        const fundList = await getTopPerformingFunds(selectedFundType, selectedPeriod);
        updateTopPerformingFundList(fundList);
    });
}

function mapWithMarkers() {
    $(".marker").hover(function () {
        const markerContent = $(this).find(".marker-content");

        if (markerContent.length == 0) return;

        markerContent.css('visibility', 'visible');
        markerContent.each((_, markerContentItem)=> {
            if (markerContentItem.getBoundingClientRect().right > window.innerWidth) {
                const dif = Math.ceil((markerContentItem.getBoundingClientRect().right - window.innerWidth)/ 50 ) * 50;
                markeContentLeftOffset = markerContentItem.offsetLeft - dif;
                markerContentItem.style.left = `${markeContentLeftOffset}px`;
            }
        })

    }, function () {
        $(this).find(".marker-content").css('visibility', 'hidden');
    });

    // mobile maps section
    if ($(".map-content-wrapper-mobile").length == 0) return;

    $(".map-content-wrapper-mobile .horizontally-scrollable-list .scrollable-item").first().addClass("active");
    $(".map-content-wrapper-mobile .scrollable-item-content").first().addClass("d-flex active").removeClass("d-none");

    $(".map-content-wrapper-mobile .horizontally-scrollable-list .scrollable-item").on("click", function (e) {

        $(".map-content-wrapper-mobile .horizontally-scrollable-list .scrollable-item.active").removeClass("active");
        $(this).addClass("active")

        //parent
        $(".map-content-wrapper-mobile .horizontally-scrollable-list .selected").removeClass("selected");
        $(this).parent().addClass("selected");

        const tabContentId = $(this).data("location-tab-topic");
        $(".map-content-wrapper-mobile .scrollable-item-content.active").removeClass("d-flex active").addClass("d-none");
        $(`.map-content-wrapper-mobile .scrollable-item-content#${tabContentId}`).addClass("d-flex active").removeClass("d-none");

        $(this)[0].scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        });
    });
}


window.addEventListener("DOMContentLoaded", ucitsHomepageScripts)
window.addEventListener("DOMContentLoaded", newsletterPopulationScripts)
window.addEventListener("DOMContentLoaded", ucitsSearchAutoComplete)
window.addEventListener("DOMContentLoaded", topPerformningFunds)
window.addEventListener("DOMContentLoaded", mapWithMarkers)